import axiosClient from "../api/axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const voucherApi = {
  getVouchers: (params) => {
    const url = "voucher";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getVoucher: (id) => {
    const url = "voucher";
    return axiosClient.get(url + "/" + id);
  },

  createVoucher: (params) => {
    const url = "voucher";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  
  updateVoucher: (id, payload) => {
    const url = "voucher/";
    return axiosClient.patch(url + id, payload);
  },

  deleteVoucher: (params) => {
    const url = "voucher";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default voucherApi;
